__turbopack_context__.v({
  "blue-container": "styles-module-scss-module__ptBBIW__blue-container",
  "body": "styles-module-scss-module__ptBBIW__body",
  "button-container": "styles-module-scss-module__ptBBIW__button-container",
  "buttons-container": "styles-module-scss-module__ptBBIW__buttons-container",
  "buttons-container-outer": "styles-module-scss-module__ptBBIW__buttons-container-outer",
  "container": "styles-module-scss-module__ptBBIW__container",
  "container-inner": "styles-module-scss-module__ptBBIW__container-inner",
  "container-inner-border": "styles-module-scss-module__ptBBIW__container-inner-border",
  "header": "styles-module-scss-module__ptBBIW__header",
  "image": "styles-module-scss-module__ptBBIW__image",
  "image-container": "styles-module-scss-module__ptBBIW__image-container",
  "paragraph": "styles-module-scss-module__ptBBIW__paragraph",
});
